module.exports = __webpack_public_path__ + "img/snow_fall_00022.e3082ceb.png";